export const containerClassName = `p-[24px_24px_32px_24px] border-t flex justify-center items-center w-full`
